import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../../../core/services/settings.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
})

export class UploadComponent {
  fileName: string;
  constructor(
    private importService: SettingsService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<UploadComponent>
  ) {}

  importFile(event) {
    var file = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file, file.name);
    this.importService.importSettings(formData).subscribe({
      next: (data) => {
        if (data.status === 200) {
          this._snackBar.open($localize `Settings imported successfully`, '', {
            duration: 3000
          });
          this.dialogRef.close();
        }
      },
    });
  }
}
